import { motion } from "framer-motion";
import { PaystackButton } from "react-paystack";

export default function Button({
  type,
  title,
  icon,
  link,
  bgColor,
  textColor,
  onClick,
  disabled,
}) {
  return (
    <>
      {type === "bgBtn" ? (
        <motion.button
          initial={{ opacity: 0, y: 30 }}
          animate={{ opacity: 1, y: 0 }}
          whileHover={{ scale: 1.05 }}
          transition={{ duration: 0.3 }}
          onClick={onClick}
          disabled={disabled}
          className={`${bgColor} hover:bg-primary ${textColor} mb-4 p-3 w-[100%] text-sm rounded uppercase flex justify-center`}
        >
          <p>{title}</p>
        </motion.button>
      ) : type === "iconBtn" ? (
        <motion.button
          initial={{ opacity: 0, y: 30 }}
          animate={{ opacity: 1, y: 0 }}
          whileHover={{ scale: 1.05 }}
          transition={{ duration: 0.3 }}
          onClick={onClick}
          disabled={disabled}
          className={`${bgColor} hover:bg-primary ${textColor} mb-4 p-3 w-[100%] text-sm rounded uppercase flex justify-center`}
        >
          {icon}
        </motion.button>
      ) : type === "disable" ? (
        <button disabled>{icon}</button>
      ) : type === "pay" ? (
        <PaystackButton />
      ) : (
        "NULL"
      )}
    </>
  );
}
